export const alertMocks = {
  content: [
    {
      text: 'Unfortunately, flights are unavailable for some of your selected dates. Alternate options are offered below.',
      linkText: ''
    }
  ],
  role: {
    type: 'select',
    options: {
      info: 'info',
      warning: 'warning',
      success: 'success',
      error: 'error'
    },
    value: 'error'
  },
  icon: true,
  title: '',
  isDisplay: true,
  customClassName: 'idp-alert__shop-advisory-message'
};
